export default __webpack_public_path__ + "static/flipImg4-dafa0339ce2081faefbda9e3938af678.webp";